var timer;
var message;

$(".status__info").hover(
  function(event) {
    var self = $(this);

    timer = setTimeout( function() {
      message = self.find('span');
      message.stop(true,false).slideDown(250);
    }, 800);

  }, function(event) {
    var self = $(this);

    clearTimeout(timer);
    setTimeout( function() {
      message = self.find('span');
      message.stop(true,false).slideUp(250);
    }, 350);
  }
);

$(".has__tooltip").hover(
  function(event) {
    var self = $(this);

    timer = setTimeout( function() {
      message = self.find('.tooltip__body');
      message.stop(true,false).slideDown(250);
    }, 400);

  }, function(event) {
    var self = $(this);

    clearTimeout(timer);
    setTimeout( function() {
      message = self.find('.tooltip__body');
      message.stop(true,false).slideUp(250);
    }, 200);
  }
);